import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { List, ListItem, Button } from './styles';
import { FolderState } from '../../../../containers/DriveItemList/reducer';
import Utils from '../../../../utils';

interface BreadcrumbsProps {
	items: FolderState[];
	onItemClick: (id: number, label: string) => void;
}

const ITEMS_TO_DISPLAY_DOTS = 3;

const getLabel = (label: string, shouldDisplayDots: boolean): string | React.ReactNode => (
	shouldDisplayDots ? '...' : <Translate value={label} />
);

const Breadcrumbs = ({ items, onItemClick }: BreadcrumbsProps) => (
	<List>
		{items.map(({ id, label }, index) => {
			const isLast = index === items.length - 1;
			const indexToDisplayDots = items.length - ITEMS_TO_DISPLAY_DOTS;
			const isHidden = index > 0 && index < indexToDisplayDots;
			const shouldDisplayDots = index > 0 && index === indexToDisplayDots;

			return (
				<ListItem
					key={id}
					hidden={isHidden}
				>
					<Button
						type="button"
						disabled={isLast}
						onClick={() => onItemClick(id, label)}
					>
						{getLabel(label, shouldDisplayDots)}
					</Button>
					{!isLast && Utils.getSvgIcon('iconset_forth')}
				</ListItem>
			);
		})}
	</List>
);

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/DrivePicker/Breadcrumbs/index.tsx